import React, { useState, useEffect, useContext } from 'react'
import Link from 'next/link'
import { FaArrowCircleUp } from 'react-icons/fa'
import Style from './Footer.module.css'
import Image from 'next/image'
import Payment from '../../public/assets/img/payment-img.png'
import { MainContext } from '../../contexts/MainContext'
import logoTech from '../../public/assets/icons/logotech.png'

const BottomFooter = () => {
	const [isVisible, setIsVisible] = useState(false)
	const { setIsLoading } = useContext(MainContext)
	useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY > 1000) {
				setIsVisible(true)
			} else {
				setIsVisible(false)
			}
		}

		window.addEventListener('scroll', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [])

	const scrollTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	}

	return (
		<div className='bg-white'>
			<div className={`${Style.copyRightWrapper} width  w-full  text-sm text-center mt-10 h-20 flex items-center justify-between mb-24 ${Style.copyRightBottom} `}>
				<div className={`copy-right ${Style.mbcopyright} margin-btm  `}>
					<p className={Style.tech_logo}>
						<span>Designed & Developed By</span>{' '}
						<a href='https://tecsolpro.com/' target='_blank' rel='noreferrer'>
							<Image src={logoTech} alt='techlogo' width={110} height={30} />
						</a>
					</p>
				</div>
				<div className={` paymentImgfooter  mt-1`}>
					<Image src={Payment} alt='payment' width={282} height={44} />
				</div>
				<FaArrowCircleUp
					className={`${Style.scrollTop}`}
					onClick={scrollTop}
					style={{
						height: 40,
						bottom: '13rem',
						right: '1rem',
						zIndex: '9',
						display: isVisible ? 'flex' : 'none'
					}}
				/>
			</div>
		</div>
	)
}

export default BottomFooter
